$(document).on('click', '.library-page__catalog-grid-load', function () {
    let that = $(this),
        url = that.attr('data-url'),
        date = that.attr('data-date'),
        offset = that.attr('data-offset'),
        totalCount = that.attr('data-total'),
        formData = new FormData();

    formData.append('offset', offset);
    formData.append('date', date);

    $.ajax({
        'cache': false,
        'type': 'POST',
        'dataType': 'json',
        'data': formData,
        'processData': false,
        'contentType': false,
        'success': function (response) {
            $('.library-page__catalog-grid-wrapper').append(response.data)

            let count = parseInt(offset) + parseInt(response.count),
                separator = $('.library-page__catalog-grid-separator').last();

            that.attr('data-offset', count);
            that.attr('data-date', separator.data('date'));

            if (count >= totalCount) {
                that.parents('.library-page__catalog-grid-load-container').remove();
            }
        },
        'url': url
    });
})